export default "__VITE_ASSET__7ec6e41f__"